<template>
    <div class="container-fluid mt-2">
        <div class="row">
            <div class="card">
                <div class="card-header"> {{ t.resellers }}
                    <a class="tag tag-danger update-all-card text-white" href="javascript:;" @click="fetchCustomers()">
                        {{ t.custom_reseller_panel.update_user_cards}}
                    </a>
                </div> <!-- tr -->
                <div class="card-block p-0">
                    <div class="easy-autocomplete">
                        <CustomerSearch usageArea="reseller" list="1"></CustomerSearch>
                    </div>
                    <input type="hidden" id="redirect">
                    <div class="table-responsive">
                        <table class="table table-striped mb-0">
                            <thead>
                            <tr>
                              <th style="width: 20%">{{ t['transaction'] }}</th>
                              <th style="width: 20%">{{ t.user.username }}</th> <!-- tr -->
                              <th style="width: 15%">{{ t.casino_giro || 'Casino GGR'}}</th>
                              <th style="width: 15%">{{ t.sport_giro || 'Sport GGR'}}</th>
                              <th style="width: 15%">{{ t.total_card_balances || 'Total Card Balances'}}</th> <!-- tr -->
                              <th style="width: 15%">{{ t.remaining_limit }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="loading">
                                <td colspan="4" align="center">
                                    <Loading></Loading>
                                </td>
                            </tr>
                            <template v-if="!loading">
                                <tr v-if="customers.length < 1">
                                    <td colspan="4" align="center">Kayıt yok</td>
                                </tr>

                              <template v-for="(customer, idx) in customers">
                                <ResellerTableRow :customer="customer"/>
                              </template>

                            </template>
                            </tbody>
                        </table>
                        <div class="fixed-table-footer">
                            <paginate v-if="pagination" class="mx-3"
                                      :page-count="pagination.pageCount"
                                      :page-range="pagination.pageRange"
                                      :force-page="pagination.current"
                                      :initialPage="pagination.current"
                                      :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                                      :click-handler="onChangePage"
                                      :prev-text="t.previous"
                                      :next-text="t.next"
                                      :container-class="'my-1 pagination float-right mr-0 ml-1'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'"
                            >
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import CustomerSearch from "../CustomerSearch";
    import Loading from "../Loading";
    import ResellerTableRow from "../row/ResellerTableRow";
    export default {
        name: "ResellerList",
        components: {Loading, CustomerSearch, Paginate, ResellerTableRow},
        data() {
            return {
                customers: [],
                session: session,
                pagination: null,
                t: this.$root.t,
                loading: false
            }
        },
        watch: {
          '$route.query.uid' () {
            this.fetchCustomers()
          },
          '$route.query.referer' () {
            this.fetchCustomers()
          }
        },
        mounted() {
            this.$router.push({query: {referer: this.$route.query.referer, page: 1}});
            this.fetchCustomers();
        },
        methods: {
            openResellerAccount(uid) {
              this.createToken(uid)
            },
            fetchCustomers() {
                this.loading = true;
                this.$http.get(api + 'api/v1/users', {
                    params: {
                        page: this.$route.query.page,
                        per_page: 10,
                        direction: 'desc',
                        uid: this.$route.query.uid,
                        group: [3],
                        referrer: this.$route.query.referer,
                        sort: 'u.balance'
                    }
                })
                    .then(response => {
                        this.customers = response.body.result.users;
                        this.pagination = null;
                        this.pagination = response.body.result.pagination;
                        this.total = response.body.result.total
                        this.loading = false;
                        this.notfound = false;
                    }, response => {
                        this.customers = [];
                        this.loading = false;
                        this.notfound = true;
                    })
            },
            onChangePage(page) {
                this.pagination.current = page;
                this.$router.push({query: {page: page}});
                window.scroll(0, 0);
                this.fetchCustomers()
            },
            openPayinModal(user, operate) {
                this.$bus.$emit('payinModal', {id: user, action: true, operate: operate})
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/ResellerList.vue